<template>
  <div class="Coin-Search">
    <p class="Coin-Search__ttl">Выбрать тикер</p>
    <template v-if="activeCoin">
      <div class="Coin-Search__choose-box">
        <div class="Coin-Search__choosen-item">
          <AvatarImage :src="activeCoin.image" :size="20"/>
          <span class="Coin-Search__choosen-symbol">{{ activeCoin.symbol }}</span>
          <span class="Coin-Search__choosen-name">{{ activeCoin.name }}</span>
        </div>
        <DeleteBinIcon_2 @click="toRemoveActiveCoin" />
      </div>
      <input :name="'coin'" v-model="activeCoin.api_id" type="hidden" />
    </template>
    <template v-else>
      <div class="Coin-Search__input-box" @click="toFocus">
        <SearchIcon />
        <input class="Coin-Search__input" placeholder="Поиск по тикерам" ref="input" @input="onInput"/>
      </div>
    </template>
    <div class="Coin-Search__output" v-if="get_isShowOutput">
      <template v-if="isLoading">
        <div class="Coin-Search__ldr">
          <LoaderCircle :color="'var(--blue-600)'"/>
        </div>
      </template>
      <template v-else-if="get_isEmpty">
        <p class="Coin-Search__empty">По данному запросу ничего не найдено</p>
      </template>
      <template v-else>
        <template v-for="coin in result" :key="coin.api_id">
          <CapsuleMain @click="toActiveCoin(coin.api_id)" :text="coin.symbol" :subtext="coin.name" :isHover="true" :icon="coin.image" />
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, nextTick, onMounted } from 'vue';
  import { debounce } from 'lodash';
  import { getCoinList } from './api/getCoinList.js';
  import { Props } from './scripts/props.js'
  //-------------------------
  import SearchIcon from '@svg/SearchIcon.vue';
  import DeleteBinIcon_2 from '@svg/DeleteBinIcon_2.vue';
  import AvatarImage from '@ui/Images/AvatarImage/AvatarImage.vue';
  import CapsuleMain from '@ui/Capsules/CapsuleMain/CapsuleMain.vue';
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  //-------------------------
  const props = defineProps(Props());
  const emit = defineEmits(['coinSelected']);
  //-------------------------
  const input = ref(null);
  const searchQuery = ref(''); 
  const result = ref([]);
  const isLoading = ref(false);
  const activeCoin = ref(null);
  //-------------------------
  onMounted(() => {
    toInitData();
  })
  //-------------------------
  //Отображать ли вывод
  const get_isShowOutput = computed(() => searchQuery.value.length > 0 && !activeCoin.value);
  //Результат поиска пустой
  const get_isEmpty = computed(() => result.value.length === 0 && searchQuery.value.length > 0);
  //-------------------------
  //Обработка ввода
  const onInput = (event) => {
    searchQuery.value = event.target.value;
    debouncedFetchCoins(searchQuery.value);
  };
  //Дебаунс-функция (вызывается через задержку)
  const debouncedFetchCoins = debounce((query) => {
    fetchCoins(query);
  }, 300);
  //Функция для обработки запроса на сервер
  const fetchCoins = async (query) => {
    toggleLoader(true);
    const response = await getCoinList(query);
    result.value = response.results;
    toggleLoader(false);
  };
  //Активировать коин
  const toActiveCoin = async (id) => {
    activeCoin.value = result.value.find(item => item.api_id === id);
    await nextTick();
    emit('coinSelected', activeCoin.value);
  }
  //Удалить активный коин
  const toRemoveActiveCoin = () => { 
    activeCoin.value = null;
    searchQuery.value = '';
    emit('coinSelected', null);
  };
  //Фокус на поле
  const toFocus = () => { input.value.focus(); }
  //Переключить флаг процесса загрузки поиска
  const toggleLoader = (status) => { isLoading.value = status };
  //Инициализировать поле
  const toInitData = () => {
    if(!props.initData) return
    activeCoin.value = props.initData;
  }
</script>

<style lang="scss">
  @import './styles/styles'; 
</style>